/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/unauthNotificationSettingsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a UnauthNotificationSettings. */
export class UnauthNotificationSettings {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a UnauthNotificationSettings.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Notification Settings API to update a specific notification setting for an unauthenticated
   * user.
   * @summary Updates a given notification setting for an unauthenticated user identified by the
   * given token.
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.UnauthNotificationSettingsUnauthUpdateSelfEmailNotificationSettingResponse>
   */
  unauthUpdateSelfEmailNotificationSetting(options?: Models.UnauthNotificationSettingsUnauthUpdateSelfEmailNotificationSettingOptionalParams): Promise<Models.UnauthNotificationSettingsUnauthUpdateSelfEmailNotificationSettingResponse>;
  /**
   * @param callback The callback
   */
  unauthUpdateSelfEmailNotificationSetting(callback: coreHttp.ServiceCallback<Models.NotificationSettingResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  unauthUpdateSelfEmailNotificationSetting(options: Models.UnauthNotificationSettingsUnauthUpdateSelfEmailNotificationSettingOptionalParams, callback: coreHttp.ServiceCallback<Models.NotificationSettingResponse>): void;
  unauthUpdateSelfEmailNotificationSetting(options?: Models.UnauthNotificationSettingsUnauthUpdateSelfEmailNotificationSettingOptionalParams | coreHttp.ServiceCallback<Models.NotificationSettingResponse>, callback?: coreHttp.ServiceCallback<Models.NotificationSettingResponse>): Promise<Models.UnauthNotificationSettingsUnauthUpdateSelfEmailNotificationSettingResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      unauthUpdateSelfEmailNotificationSettingOperationSpec,
      callback) as Promise<Models.UnauthNotificationSettingsUnauthUpdateSelfEmailNotificationSettingResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const unauthUpdateSelfEmailNotificationSettingOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/UnauthNotificationSettings",
  queryParameters: [
    Parameters.token
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UnauthNotificationSettingPayload
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.NotificationSettingResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
